import { useAdministrativeContext } from '../../../../../../pages/administrativePanel/administrativePanelContext'
import { useState, useCallback, useEffect } from 'react'
import { BusinessList } from './businessList'
import { InputContent } from './inputContent'
import { StatusFilter } from './statusFilter'
import { FaArrowLeft } from 'react-icons/fa'
import { api } from '../../../../../../services/api'
import { toast } from 'react-toastify'


import { StickyContainer } from './style'


export function IndividualSelection({ setSelectionDetails }) {
    const { setLoadingButtonSeeMore } = useAdministrativeContext()
    const [listSearchBusiness, setListSearchBusiness] = useState([])
    const [showingFilteredBusiness, setShowingFilteredBusiness] = useState(false)
    const [handleTermSearch, setHandleTermSearch] = useState('')
    const [pageSearch, setPageSearch] = useState(20)
    const [searchLoading, setSearchLoading] = useState(false)
    const [statusSelected, setStatusSelected] = useState(0)


    const seeMoreSearchBusiness = useCallback(async () =>  {
        setLoadingButtonSeeMore(true)
        try{
            const response = await api.get(`/getBusinessAdm/?quantity=${pageSearch}&search=${handleTermSearch}&sync=${statusSelected}`, {
                headers: {
                  token: localStorage.getItem('@Inoveclube:token')
                }
            })
    
            const { business, next_page } = response.data
            const pageNumber = next_page ? (pageSearch + 20) : null
          
            setListSearchBusiness(business)
            setPageSearch(pageNumber)
            setLoadingButtonSeeMore(false)
        }catch{
            setLoadingButtonSeeMore(false)
            toast.error('Tente novamente')
        }
      
    }, [handleTermSearch, setListSearchBusiness, setPageSearch, pageSearch, setLoadingButtonSeeMore, statusSelected])

    
    useEffect(() => {
        if(!showingFilteredBusiness){
            setHandleTermSearch('')
        }
    }, [showingFilteredBusiness])


    return(
        <>
            <StickyContainer>
               <button onClick={() => setSelectionDetails(null)}>
                    <FaArrowLeft /> Menu Principal
               </button>

                <InputContent 
                    setListSearchBusiness={setListSearchBusiness}
                    setHandleTermSearch={setHandleTermSearch}
                    setPageSearch={setPageSearch}
                    setSearchLoading={setSearchLoading}
                    setShowingFilteredBusiness={setShowingFilteredBusiness}
                    statusSelected={statusSelected}
                />
                
                
                <StatusFilter 
                    statusSelected={statusSelected}
                    setStatusSelected={setStatusSelected}
                    handleTermSearch={handleTermSearch}
                    setSearchLoading={setSearchLoading}
                    setPageSearch={setPageSearch}
                    setListSearchBusiness={setListSearchBusiness}
                    setShowingFilteredBusiness={setShowingFilteredBusiness}
                /> 
            </StickyContainer>

            <BusinessList 
                listSearchBusiness={listSearchBusiness} 
                seeMoreSearchBusiness={seeMoreSearchBusiness}
                pageSearch={pageSearch}
                searchLoading={searchLoading}
                showingFilteredBusiness={showingFilteredBusiness}
                setShowingFilteredBusiness={setShowingFilteredBusiness}
                setStatusSelected={setStatusSelected}
                setListSearchBusiness={setListSearchBusiness}
            />
        </>
    ) 
}
